import BaseService from 'services/base'

export default class OidcService extends BaseService {
  constructor(api) {
    const url = '/sso/oidc'
    super(api, url)
    this.api = api
    this.url = url
  }

  getLoginUrl(code, payload) {
    return this.get(`${code}/login`, payload)
  }
}
